import { render, staticRenderFns } from "./ThgSustainableTrees.vue?vue&type=template&id=8c1a7004&scoped=true"
import script from "./ThgSustainableTrees.vue?vue&type=script&lang=ts"
export * from "./ThgSustainableTrees.vue?vue&type=script&lang=ts"
import style0 from "./ThgSustainableTrees.vue?vue&type=style&index=0&id=8c1a7004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1a7004",
  null
  
)

export default component.exports